<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">Welcome to <span class="gold">WorldTumbler</span></h2>
  </div>

  <p class="wz-lead">
    Build a <strong>stubbed wiki with no AI</strong>, let <strong>AI fill in everything</strong>, or use AI only where you
    want it. Traditional, assisted or fully automated: the choice is yours.
  </p>
  <p class="wz-lead">
    WorldTumbler works with maps made in <strong>Azgaar's Fantasy Map Generator</strong> (AFMG), a powerful tool that can
    be as simple or as detailed as you like.
  </p>

  <div class="wz-card welcome-tutorial">
    <div>
      <p class="wz-card-title">New to Azgaar's Fantasy Map Generator?</p>
      <p class="wz-muted">YouTube creator Bepis has excellent tutorials to watch before you start.</p>
    </div>
    <button type="button" class="btn btn-dark" (click)="openLink('https://youtu.be/6MFiHXAVUUY?si=-G_qFIRL_rtkxOHk')">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>
      Watch videos
    </button>
  </div>

  <div class="wz-card welcome-creators">
    <p class="wz-card-title">Please support these creators</p>
    <div class="creator-row">
      <span class="creator-name">Azgaar's Fantasy Map Generator</span>
      <span class="creator-links">
        <a class="btn btn-dark btn-sm" href="https://azgaar.github.io/Fantasy-Map-Generator/" target="_blank" rel="noopener noreferrer">Website</a>
        <a class="btn btn-dark btn-sm" href="https://www.patreon.com/c/azgaar/home" target="_blank" rel="noopener noreferrer">Patreon</a>
      </span>
    </div>
    <div class="creator-row">
      <span class="creator-name">Watabou's Procgen Arcana</span>
      <span class="creator-links">
        <a class="btn btn-dark btn-sm" href="https://watabou.github.io/city-generator/" target="_blank" rel="noopener noreferrer">Website</a>
        <a class="btn btn-dark btn-sm" href="https://www.patreon.com/cw/watawatabou" target="_blank" rel="noopener noreferrer">Patreon</a>
      </span>
    </div>
  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>
</div>
